import store from '../store'
import router from '../router'
import { Toast } from 'vant'
// import Config from '../config'

function getCurrentZoneTime() {
  const offset = new Date().getTimezoneOffset()
  const current = Math.abs(offset * 60)
  return current
}

let websock

// const apiUrl = Config.baseURL.replace('http', 'ws')

class Websocket {
  // constructor(room_id, user_id) {
  //   console.log(room_id)
  //   this.room_id = room_id
  //   this.user_id = user_id
  //   const Authorization = localStorage.getItem('access_token')
  //   const wsuri = `${apiUrl}ws/game/controller/${room_id}/${user_id}`
  //   websock = new WebSocket(wsuri, ['Co-Authorization', Authorization])
  //   websock.onmessage = Websocket.websocketonmessage
  //   websock.onopen = Websocket.websocketonopen
  //   websock.onerror = Websocket.websocketonerror
  //   websock.onclose = Websocket.websocketclose
  // }

  constructor(wsuri) {
    const Authorization = localStorage.getItem('access_token')
    websock = new WebSocket(wsuri, ['Co-Authorization', Authorization, 'time-zone-offset-seconds', getCurrentZoneTime()])
    websock.onmessage = Websocket.websocketonmessage
    websock.onopen = Websocket.websocketonopen
    websock.onerror = Websocket.websocketonerror
    websock.onclose = Websocket.websocketclose
  }

  static websocketonopen() {    //连接建立之后执行send方法发送数据
    // Websocket.websocketsend(JSON.stringify(actions))
  }

  static websocketonerror() {    //连接建立失败重连
    // new Websocket(this.room_id, this.user_id)
  }

  static websocketonmessage(e) {    //数据接收
    const data = JSON.parse(e.data)
    console.log(data)
    store.commit('setWebData', { ...data })
  }

  static websocketsend(Data) {    //数据发送
    console.log(Data)
    websock.send(Data)
  } 

  static websocketclose({code}) {  //关闭
    if (code === 1006) {
      Toast({message: '网络错误断开链接', className: 'toast-trans'})
    }
    if (store.getters.webData.state_code === 8) {
     Toast({ message: '体力值不足', className: 'toast-trans' })
    }
    store.commit('setRoomId', '')
    router.replace('index')
    // new Websocket(this.room_id, this.user_id)
  }
}

export default Websocket
